import { useServices } from "contexts/ServiceContext";
import { DocumentNode } from "graphql";
import { useCallback } from "react";

type TRunOperation<T, TVariables> = (variables: TVariables) => Promise<T>;
type TOperationHook<T, TVariables> = [TRunOperation<T, TVariables>];

function useGQLOperation<T, TVariables>(operation: DocumentNode): TOperationHook<T, TVariables> {
    const { GqlService } = useServices();

    const execute = useCallback(
        async (variables: TVariables) => {
            return GqlService.request<T, TVariables>(operation, variables);
        },
        [operation, GqlService],
    );

    return [execute];
}

export default useGQLOperation;
